import React from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';

import WorkerSettingsStore from '../services/workerSettings/WorkerSettingsStore';
import WorkerSettingsContext from '../services/workerSettings/WorkerSettingsContext';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import {
  FacePictureSearchForm,
  CcusSearchForm,
} from '../components/searchmenus/WorkerSettingsSearch';
import { FacePictureTableLayout } from '../components/tables/WorkerSettingsFacePictureTable';
import { CcusTableLayout } from '../components/tables/WorkerSettingsCcusTable';
import { Information } from '../components/modals/common';
import { messageUtility } from '../utilities/messageUtility';
import {
  isPartnerCompanyRoleId,
  isPrimaryCompanyRoleId,
} from '../utilities/roleUtility';
import { DIALOG_STATUS, WORKER_SETTING_TAB } from '../utilities/constants';
import Styles from '../styles/componentStyle/workerSettings/WorkerSettings.scss';
import { Description } from '../components/Description';

/**
 * 作業員設定状況一覧画面
 */
export class WorkerSettings extends React.Component {
  constructor(props) {
    super(props);
  }

  // 画面表示
  render() {
    return (
      <WorkerSettingsStore>
        <WorkerSettingsContext.Consumer>
          {({
            state,
            changeTab,
            closeDialog,
            infiniteScrollLoad,
            executeIntegration,
            toggleThumbnails,
            csvDownloadPreparation,
            handleCloseCsvExportErrorDialog,
          }) => {
            const renderVisibleThumbnailsCheckbox = () => {
              return (
                <label
                  htmlFor='check'
                  className='checkbox setting-header__thumbnail-toggler'
                >
                  <input
                    type='checkbox'
                    id='check'
                    name='isVisibleThumbnails'
                    checked={state.isVisibleThumbnails}
                    onChange={toggleThumbnails}
                  />
                  <i className='i-square i-3x' aria-hidden='true' />
                  <span className='form-list__item-text'>
                    一覧に顔写真を表示する
                  </span>
                </label>
              );
            };
            const renderDescription = () => {
              return isPrimaryCompanyRoleId(state.roleId)
                ? data.description.prime
                : data.description.partner;
            };

            return (
              <React.Fragment>
                <div id='main' className={`${Styles.main} main`}>
                  <Helmet title={data.title} />
                  <div className='main__header'>
                    <h1>{data.title}</h1>
                  </div>

                  {state.showTab && (
                    <div className='tab-area'>
                      {_.map(WORKER_SETTING_TAB, item => (
                        <React.Fragment key={item.id}>
                          <input
                            type='radio'
                            className='tab'
                            id={`tab${item.id}`}
                            checked={state.selectedTabId === item.id}
                            onChange={() => changeTab(item.id)}
                            readOnly
                          />
                          <label htmlFor={`tab${item.id}`}>{item.title}</label>
                        </React.Fragment>
                      ))}
                    </div>
                  )}

                  <div id='infinityscroll-target' className='main__body'>
                    {/* 顔写真タブ */}
                    {state.selectedTabId ===
                      WORKER_SETTING_TAB.FACE_PICTURE.id && (
                      <React.Fragment>
                        <div id='setting-header' className='setting-header'>
                          <div className='setting-header__item'>
                            <button
                              className='btn--sub'
                              onClick={csvDownloadPreparation}
                            >
                              CSV出力
                            </button>
                          </div>
                          <div className='setting-header__item'>
                            <Description>
                              {isPrimaryCompanyRoleId(state.roleId) && (
                                <button
                                  className={`setting-header__face-regist-btn btn-fixedsize--effective`}
                                  disabled={
                                    state.canUseFaceRegisterButton === false
                                  }
                                  onClick={() => {
                                    executeIntegration();
                                  }}
                                >
                                  {data.button.integration}
                                </button>
                              )}
                              {renderDescription()}
                            </Description>
                          </div>
                          <div className='setting-header__item'>
                            {(isPrimaryCompanyRoleId(state.roleId) ||
                              isPartnerCompanyRoleId(state.roleId)) &&
                              renderVisibleThumbnailsCheckbox()}
                          </div>
                        </div>

                        <FacePictureSearchForm propertyName='searchForm' />
                        <FacePictureTableLayout
                          isVisibleThumbnails={state.isVisibleThumbnails}
                        />
                      </React.Fragment>
                    )}

                    {/* CCUS連携 */}
                    {state.selectedTabId === WORKER_SETTING_TAB.CCUS.id && (
                      <React.Fragment>
                        <CcusSearchForm propertyName='searchForm' />
                        <CcusTableLayout />
                      </React.Fragment>
                    )}

                    <InfinityScrollLoad
                      targetId='infinityscroll-target'
                      total={state.searchForm.total}
                      reset={state.canLoadMore}
                      callback={infiniteScrollLoad}
                    />
                  </div>
                </div>

                <Information
                  title={state.informationModal.title}
                  message={state.informationModal.message}
                  buttonText={state.informationModal.buttonText}
                  multilineText={state.informationModal.multilineText}
                  visible={dataDialogStatus.includes(state.dialogStatus)}
                  onClose={() => closeDialog()}
                />
                <Information
                  message={messageUtility.getMessage('E-002-007-04')}
                  buttonText={messageUtility.getMessage('I-000-017')}
                  visible={state.isCsvExportErrorDialog}
                  onClose={handleCloseCsvExportErrorDialog}
                  rootClassName={'inline-dialog-md'}
                  multilineText
                />
              </React.Fragment>
            );
          }}
        </WorkerSettingsContext.Consumer>
      </WorkerSettingsStore>
    );
  }
}

const dataDialogStatus = [
  DIALOG_STATUS.registerStartDialogEnabled.id,
  DIALOG_STATUS.notExistFieldIdDialogEnabled.id,
  DIALOG_STATUS.otherErrorDialogEnabled.id,
  DIALOG_STATUS.updateSuccessDialogEnabled.id,
  DIALOG_STATUS.updateFailedDialogEnabled.id,
];

// 定数
const data = {
  title: '作業員設定状況一覧',
  button: {
    integration: '顔写真情報を機器に送信する',
  },
  description: {
    prime: (
      <p>
        顔写真情報の登録・変更・削除があった場合は、夜間に変更内容が機器に自動で送信されます。
        <br />
        変更内容をすぐに機器に反映させたい場合は「顔写真情報を機器に送信する」をクリックしてください。
      </p>
    ),
    partner: (
      <p>
        顔写真情報の登録・変更・削除があった場合は、夜間に変更内容が機器に自動で送信されます。
        <br />
        変更内容をすぐに機器に反映させたい場合は、元請ユーザーに手動送信を依頼してください。
      </p>
    ),
  },
};



// WEBPACK FOOTER //
// ./src/pages/WorkerSettings.jsx